import React, { ReactElement } from 'react';
import { YesOrNoStepCreator } from '../../shared/YesOrNoStepCreator/YesOrNoStepCreator';
import { NavigationButtons } from '../../shared/NavigationButtons/NavigationButtons';
import { Formik, Form } from 'formik';
import { CoverageCheckupState, goToNextStep, updateCoverageCheckupState } from '../../../store/step';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store/store';
import { createYesNoObjectSchema } from '../../schema/yesNoNotSureSchema';
import { CardPadding } from '../../shared/CardStyles';
import { CardHeader } from '../../shared/CardStyles/CardHeader';
import { useFormInteractionTracking } from '../../../hooks/useFormInteractionTracking';

function HighDeductiblePlanStep(): ReactElement {
  const dispatch = useDispatch();
  const { hdhpPossessed: hdhpPossessed } = useSelector(
    (state: RootState) => state.steps
  );

  const formRef = useFormInteractionTracking('have_hdhp');

  function onSubmit(values: Partial<CoverageCheckupState>): void {
    dispatch(updateCoverageCheckupState(values));
    dispatch(goToNextStep());
  }

  return (
    <CardPadding>
      <CardHeader
        header="Do you have a high deductible health plan?"
        subHeader="A high deductible health plan is a type of health insurance with lower
        monthly premiums and higher deductibles."
      />

      <Formik
        initialValues={{ hdhpPossessed }}
        onSubmit={onSubmit}
        validationSchema={createYesNoObjectSchema('hdhpPossessed')}
      >
        <Form ref={formRef}>
          <YesOrNoStepCreator name="hdhpPossessed" showNotSure={true} />

          <NavigationButtons />
        </Form>
      </Formik>
    </CardPadding>
  );
}

export { HighDeductiblePlanStep };
